module.exports = __webpack_public_path__ + "img/124.fde9e1b7.jpg";